










































































import { get } from 'vuex-pathify';
import Vue from 'vue';
import { VueAuthenticate } from 'vue-authenticate';
import { AxiosError, AxiosResponse } from 'axios';
import { axios } from '@/plugins/axios';

const vueAuth = new VueAuthenticate(axios, {
  baseUrl: process.env.VUE_APP_DEV_API_URL,
  providers: {
    eventbrite: {
      name: 'eventbrite',
      url: 'v1/eventbrite/auth/',
      clientId: '4OV5Q7CYXW5GNRYPX3',
      authorizationEndpoint: 'https://www.eventbrite.com/oauth/authorize',
      redirectUri: 'http://localhost:8080',
      //requiredUrlParams: [],
      optionalUrlParams: ['display'],
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 640, height: 633 }
    },

    facebook: {
      name: 'facebook',
      url: 'v1/facebook/auth/',
      clientId: '239983713936958',
      authorizationEndpoint: 'https://www.facebook.com/v3.0/dialog/oauth',
      redirectUri: 'http://localhost:8080/',
      requiredUrlParams: ['display', 'scope'],
      scope: ['pages_manage_posts', 'pages_read_engagement'],
      scopeDelimiter: ',',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 580, height: 400 }
    },

    linkedin: {
      name: 'linkedin',
      url: 'v1/linkedin/auth/',
      clientId: '77etnvpzux0fvp',
      authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
      //redirectUri: 'http://localhost:8080/auth/linkedin/complete-oauth',
      redirectUri: 'http://localhost:8080/',
      requiredUrlParams: ['display', 'scope'],
      scope: ['r_liteprofile', 'w_member_social'],
      scopeDelimiter: ' ',
      oauthType: '2.0',
      popupOptions: { width: 527, height: 582 }
    },

    twitter: {
      name: 'twitter',
      url: 'v1/twitter/auth/',
      authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
      redirectUri: 'http://localhost:8080',
      oauthType: '1.0',
      popupOptions: { width: 495, height: 645 }
    },

    zoom: {
      name: 'zoom',
      url: 'v1/zoom/auth/',
      clientId: 'TUZp648zQ3eHYj5WRcvLFQ',
      authorizationEndpoint: 'https://zoom.us/oauth/authorize',
      //redirectUri: 'http://a1b622af.ngrok.io/api/v1/zoom/complete-oauth',
      redirectUri: 'http://localhost:8080',
      requiredUrlParams: ['scope'],
      optionalUrlParams: ['display'],
      scope: [
        'meeting:read',
        'meeting:write',
        'user:read',
        'user:write',
        'user_profile'
      ],
      display: 'popup',
      oauthType: '2.0',
      popupOptions: { width: 452, height: 633 }
    }
  }
});

export default {
  name: 'User-Integrations',
  components: {},
  data: () => ({
    searchQuery: '',
    loading: true,
    apps: [
      {
        color: '#ff8000',
        icon: 'mdi-eventbrite',
        name: 'EventBrite',
        provider: 'eventbrite',
        description: 'Connect to use Eventbrite related services',
        status: vueAuth.isAuthenticated()
      },
      {
        color: 'blue',
        icon: 'mdi-facebook',
        name: 'Facebook',
        provider: 'facebook',
        description: 'Connect to use Facebook related services',
        status: vueAuth.isAuthenticated()
      },
      {
        color: 'blue',
        icon: 'mdi-linkedin',
        name: 'LinkedIn',
        provider: 'linkedin',
        description: 'Connect to use LinkedIn related services',
        status: vueAuth.isAuthenticated()
      },
      {
        color: 'blue',
        icon: 'mdi-twitter',
        name: 'Twitter',
        provider: 'twitter',
        description: 'Connect to Twtter related services',
        status: vueAuth.isAuthenticated()
      },
      {
        avatar:
          'https://lh3.googleusercontent.com/1DqxbUca62LmV1ehZirHGWYBef9Jrtl3DhZ4m6YBnWCUX-XNr3lcnYKb31R-7ukpKAw',
        name: 'Zoom',
        provider: 'zoom',
        description: "Welcome to Zoom's API",
        status: vueAuth.isAuthenticated()
      }
    ]
  }),
  computed: {
    miniCompanyImage: get('app/miniCompanyImage'),
    twitterUsage: () => vueAuth.isAuthenticated()
  },
  methods: {
    async authenticate(provider: string) {
      await vueAuth
        .authenticate(provider)
        .then(function(response: AxiosResponse) {
          console.log({ response });

          console.log(`${provider} authentication successful`);
        })
        .catch(function(error: any) {
          console.log({ error: error });

          console.log(`${provider} authentication failed`);
        });
    }
  }
};
